import { useEffect, useRef } from 'react';

import { MovingAnimationStyled } from './styled';

import locationLottie from 'src/animation/location-lottie.json';

import clsx from 'clsx';
import lottie from 'lottie-web';

interface MovingAnimationProps {
  className?: string;
}

const MovingAnimation = ({ className }: MovingAnimationProps) => {
  const animationContainer = useRef(null);
  useEffect(() => {
    if (animationContainer.current) {
      lottie.loadAnimation({
        container: animationContainer.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: locationLottie,
      });
    }
  }, [animationContainer.current]);

  return (
    <MovingAnimationStyled className={clsx('MovingAnimation', className)}>
      <div className="animation" ref={animationContainer}></div>
      <div className="message">
        목적지로 이동중 입니다... <br /> 잠시만 기다려주세요
      </div>
    </MovingAnimationStyled>
  );
};

export default MovingAnimation;
